function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MUITable from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import TableRow from '@material-ui/core/TableRow';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/styles';
import { useWindowSize } from '@tecsinapse/ui-kit';
import { TableCell } from '@material-ui/core';
import { styleDivContainer, tableStyles } from './utils/tableStyle';
import RowFilters from './Rows/RowFilters/RowFilters';
import { Mobile } from './Mobile/Mobile';
import Header from './Rows/Header/Header';
import Rows from './Rows/Rows';
import Toolbar from './Toolbar/Toolbar';
import Pagination from './Pagination/Pagination';
import { toolbarOptionsTypes } from './utils/propTypes';
import { Loading } from './Loading';
import { initializeColumns, initializeFilters, initializeSortFunc, isRemoteData, onChangeHeaderFilter, onChangePage, onChangeSortFilter, onChangeStartStopIndex } from './utils/tableFunctions';
import { useInitialCheckboxData, useInitialData, useUpdateDataProp, useUpdateDataRemote, useUpdatePageData } from './utils/tableHooks';
import Exporter from './Exporter/Exporter';

var TableComponent = function TableComponent(props) {
  var originalData = props.data,
      columns = props.columns,
      options = props.options,
      selectedData = props.selectedData,
      rowId = props.rowId,
      onSelectRow = props.onSelectRow,
      actions = props.actions,
      toolbarOptions = props.toolbarOptions,
      pagination = props.pagination,
      rowsPerPageOptions = props.rowsPerPageOptions,
      rowsPerPageProp = props.rowsPerPage,
      pageProp = props.page,
      exportOptions = props.exportOptions,
      propClasses = props.classes,
      forceCollapseActions = props.forceCollapseActions,
      verticalActions = props.verticalActions,
      onRowClick = props.onRowClick,
      tableToolbarHide = props.tableToolbarHide,
      tableHeaderHide = props.tableHeaderHide,
      id = props.id,
      sortFunc = props.sortFunc,
      variant = props.variant,
      labelShowLess = props.labelShowLess,
      labelShowMore = props.labelShowMore,
      empytStateComponent = props.empytStateComponent,
      hideSelectFilterLabel = props.hideSelectFilterLabel,
      customAdvancedFilters = props.customAdvancedFilters,
      customRow = props.customRow,
      _props$onDrawerClose = props.onDrawerClose,
      onDrawerClose = _props$onDrawerClose === void 0 ? function () {} : _props$onDrawerClose;
  var classes = tableStyles(useWindowSize()[1]);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      rowCount = _useState2[0],
      setRowCount = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      pageData = _useState6[0],
      setPageData = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedRows = _useState8[0],
      setSelectedRows = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      loading = _useState10[0],
      setLoading = _useState10[1];

  var _useState11 = useState(function () {
    return initializeFilters(pagination, rowsPerPageOptions, rowsPerPageProp, pageProp, toolbarOptions, initializeSortFunc(sortFunc));
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      filters = _useState12[0],
      setFilters = _useState12[1]; // Update the device


  var breakpoint = useMediaQuery(useTheme().breakpoints.down('xs'));
  var mobile = variant === 'mobile' || variant === 'auto' && breakpoint;
  var tableColumns = initializeColumns(columns, options, actions);
  useInitialData(originalData, setData);
  useInitialCheckboxData(selectedData, setSelectedRows); // Only one update data is executed, depends on type of originalData

  useUpdateDataRemote(originalData, setLoading, setData, filters, setRowCount, mobile);
  useUpdateDataProp(originalData, setLoading, setData, filters, setRowCount);
  useUpdatePageData(isRemoteData(originalData), data, setPageData, filters);
  var paginationOptions = {
    rowsPerPageOptions: rowsPerPageOptions,
    rowsPerPage: filters.rowsPerPage,
    page: filters.page,
    rowCount: rowCount,
    pagination: pagination,
    onChangePage: onChangePage(setFilters),
    tableColumns: tableColumns
  };
  var someColumnHasFilter = columns.some(function (_ref) {
    var _ref$options = _ref.options,
        columnOptions = _ref$options === void 0 ? {} : _ref$options;
    return columnOptions.filter;
  });
  var style = !mobile ? styleDivContainer : {};
  return /*#__PURE__*/React.createElement("div", {
    className: propClasses.root,
    id: id,
    style: style
  }, /*#__PURE__*/React.createElement(Loading, {
    loading: loading
  }), /*#__PURE__*/React.createElement(Toolbar, {
    options: toolbarOptions,
    selectedRows: selectedRows,
    selection: options.selection,
    exportOptions: exportOptions,
    data: isRemoteData(originalData) ? originalData : data,
    filters: filters,
    setFilters: setFilters,
    columns: columns,
    setLoading: setLoading,
    rowCount: rowCount,
    tableToolbarHide: tableToolbarHide,
    mobile: mobile,
    customAdvancedFilters: customAdvancedFilters,
    onDrawerClose: onDrawerClose
  }), mobile ? /*#__PURE__*/React.createElement("div", {
    className: propClasses.rootMobile || classes.rootMobile
  }, /*#__PURE__*/React.createElement(Mobile, {
    columns: columns,
    rowId: rowId,
    onRowClick: onRowClick,
    actions: actions,
    rowCount: rowCount,
    data: data,
    onChangeStartStopIndex: onChangeStartStopIndex(setFilters),
    labelShowLess: labelShowLess,
    labelShowMore: labelShowMore,
    page: filters.page,
    tableHeaderHide: tableHeaderHide,
    empytStateComponent: empytStateComponent
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MUITable, {
    className: classes.table
  }, /*#__PURE__*/React.createElement(Header, {
    columns: tableColumns,
    selectedRows: selectedRows,
    setSelectedRows: setSelectedRows,
    data: pageData,
    onSelectRow: onSelectRow,
    rowId: rowId,
    tableHeaderHide: tableHeaderHide,
    filters: filters,
    onChangeSortFilter: onChangeSortFilter(setFilters)
  }), /*#__PURE__*/React.createElement(TableBody, null, /*#__PURE__*/React.createElement(RowFilters, {
    rendered: someColumnHasFilter,
    columns: tableColumns,
    data: originalData,
    onChangeFilter: onChangeHeaderFilter(setFilters),
    hideSelectFilterLabel: hideSelectFilterLabel
  }), /*#__PURE__*/React.createElement(Rows, {
    columns: tableColumns,
    forceCollapseActions: forceCollapseActions,
    verticalActions: verticalActions,
    data: pageData,
    rowId: rowId,
    onRowClick: onRowClick,
    selectedRows: selectedRows,
    setSelectedRows: setSelectedRows,
    onSelectRow: onSelectRow,
    empytStateComponent: empytStateComponent,
    customRow: customRow
  })), /*#__PURE__*/React.createElement(TableFooter, null, /*#__PURE__*/React.createElement(TableRow, null, (exportOptions === null || exportOptions === void 0 ? void 0 : exportOptions.position) === 'footer' && /*#__PURE__*/React.createElement(TableCell, {
    colSpan: Math.ceil(columns.length / 2) || 1
  }, /*#__PURE__*/React.createElement(Exporter, _extends({}, exportOptions, {
    data: data,
    columns: columns,
    filters: filters,
    setLoading: setLoading,
    rowCount: rowCount
  }))), /*#__PURE__*/React.createElement(Pagination, paginationOptions))))));
};

TableComponent.defaultProps = {
  data: [],
  onFilterData: null,
  options: {},
  selectedData: [],
  onSelectRow: null,
  onRowClick: null,
  tableToolbarHide: false,
  tableHeaderHide: false,
  actions: [],
  verticalActions: false,
  toolbarOptions: {},
  pagination: false,
  rowsPerPageOptions: [10, 20, 30],
  rowsPerPage: null,
  page: 0,
  exportOptions: {
    position: 'header'
  },
  id: null,
  classes: {},
  variant: 'auto',
  labelShowLess: 'MOSTRAR MENOS',
  labelShowMore: 'MOSTRAR MAIS',
  empytStateComponent: undefined,
  hideSelectFilterLabel: false,
  customAdvancedFilters: undefined,
  customRow: undefined
};
TableComponent.propTypes = {
  /** Table columns options. Please note `defaultSort` option initializes a single column sorted in the order provided. Do not use more then one defaultSort field at a time. */
  columns: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    field: PropTypes.string.isRequired,
    options: PropTypes.shape({
      filter: PropTypes.bool,
      sort: PropTypes.bool,
      defaultSort: PropTypes.oneOf(['ASC', 'DESC'])
    }),
    customRender: PropTypes.func
  })).isRequired,

  /** Data object or function loader */
  data: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.func]),

  /** On data filter funtion handler */
  onFilterData: PropTypes.func,

  /** Set vertical actions table */
  verticalActions: PropTypes.bool,

  /** Row identifier */
  rowId: PropTypes.func.isRequired,

  /** Set table selectable rows */
  options: PropTypes.shape({
    selection: PropTypes.bool
  }),

  /** Object containing selected rows */
  selectedData: PropTypes.arrayOf(PropTypes.object),

  /** Row selection handler */
  onSelectRow: PropTypes.func,

  /** Row click handler */
  onRowClick: PropTypes.func,
  id: PropTypes.string,

  /** Configure table actions */
  actions: PropTypes.arrayOf(PropTypes.shape({
    tooltip: PropTypes.string,
    icon: PropTypes.object,
    onClick: PropTypes.func,
    visible: PropTypes.func,
    labelColor: PropTypes.string,
    label: PropTypes.string,
    bottomDivider: PropTypes.bool
  })),

  /** Table toolbar options. Check accepted attributes [here](https://github.com/tecsinapse/table/blob/master/src/Table/TablePropTypes.js#L3) */
  toolbarOptions: toolbarOptionsTypes,

  /** Enable table pagination */
  pagination: PropTypes.bool,

  /** Hide table toolbar */
  tableToolbarHide: PropTypes.bool,

  /** Hide table header */
  tableHeaderHide: PropTypes.bool,

  /** Number of rows per page available to be selected */
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),

  /** Rows to be rendered per page if paginated */
  rowsPerPage: PropTypes.number,

  /** Current page number */
  page: PropTypes.number,

  /** CSS classes applied to root div */
  classes: PropTypes.shape({
    root: PropTypes.string,
    rootMobile: PropTypes.string
  }),

  /** Set options for exporting table. If custom `type` is provided, you have to set `exportFunc` and `label` */
  exportOptions: PropTypes.shape({
    exportFileName: PropTypes.string,
    position: PropTypes.oneOf(['header', 'footer']),
    exportTypes: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.oneOf(['csv', 'custom']),
      label: PropTypes.string,
      delimeter: PropTypes.string,
      exportFunc: PropTypes.func
    }))
  }),

  /** Set table variant view */
  variant: PropTypes.oneOf(['auto', 'mobile', 'web']),

  /** Label for mobile show less button */
  labelShowLess: PropTypes.string,

  /** Label for mobile show more button */
  labelShowMore: PropTypes.string,

  /** Empty state component to display */
  empytStateComponent: PropTypes.node,

  /** Hide floating label of select filter */
  hideSelectFilterLabel: PropTypes.bool,

  /** Replace table advanced filters to your own. */
  customAdvancedFilters: PropTypes.shape({
    applyFilters: PropTypes.func,
    filters: PropTypes.node,
    cleanFilters: PropTypes.func,
    cleanFiltersLabel: PropTypes.string
  }),

  /** Provides custom row render. See examples for more detailed use cases. */
  customRow: PropTypes.func,

  /** Callback when closing advanced filters. */
  onDrawerClose: PropTypes.func
};
export var Table = TableComponent;
export default Table;